<template>
  <!-- 投诉公示 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="4">
          <div class="layout-logo">
            <a href="/"> <img src="../assets/logo-title-v3.png" alt="" /></a>
          </div>
          <div class="layout-nav">
            <!-- <MenuItem style="font-size: 18px !important" name="1" to="/sourceInformation">
            aa信息
            </MenuItem>
            <MenuItem to="/vehicleInformation" style="font-size: 18px !important" name="2">
            bb信息
            </MenuItem> -->
            <MenuItem to="/complaintPublicity" style="font-size: 18px !important" name="3">
            评价公示
            </MenuItem>
            <MenuItem to="/evaluationPublicity" style="font-size: 18px !important" name="4">
            投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem to="/customerServiceContact" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-1">投诉建议</MenuItem>
              <MenuItem to="/contactUs" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-2">联系我们</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <div class="Header-img"></div>
      <!-- 中 -->
      <Content>
        <!--  -->
        <div style="display: flex; justify-content: center; margin: 40px 0"></div>
        <!--  -->
        <div style="display: flex; justify-content: center; margin-bottom: 40px">
          <div></div>
          <div class="Content-tblo">
            <el-row>
              <el-col :span="24">
                <div class="Content-table">
                  <el-table :data="tableData" :header-cell-style="{
                      background: '#eef1f6',
                      color: '#606266',
                    }" height="650" style="width: 100%" ref="table" @cell-mouse-enter="move"
                    @cell-mouse-leave="remove">
                    >
                    <el-table-column align="center" prop="msgType" width="110" label="类别">
                      <template slot-scope="scope">
                        {{ scope.row.msgType == "1" ? "咨询" : "投诉" }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="createTime" label="发起时间" width="210">
                    </el-table-column>
                    <el-table-column align="center" prop="phone" label="发起人" width="150">
                      <template slot-scope="scope">
                        {{ scope.row.name | filtersName }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="phone" label="手机号" width="150">
                      <template slot-scope="scope">
                        {{ scope.row.phone | filtersPhone }}
                      </template>
                    </el-table-column>

                    <el-table-column align="center" prop="describes" label="发起内容">
                      <!-- <template slot-scope="scope">
                        <div>
                          <div>对方： {{ scope.row.phone | filtersPhone }}</div>
                          <div
                            style="
                              width: 500px;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              margin-top: 10px;
                            "
                          >
                            赵金芝基于单据号：20210420000000对南阳安泰达物联科技有限公司发起投诉：货损
                            发
                          </div>
                          <div style="margin-top: 10px">
                            发布时间：2021-04-20 17:17:40
                          </div>
                        </div>
                      </template> -->
                    </el-table-column>

                    <el-table-column align="center" prop="updateTime" label="结束时间" width="210">
                    </el-table-column>
                    <el-table-column align="center" prop="level" label="处理满意度" width="210">
                      <template slot-scope="scope">
                        <div v-if="
                            scope.row.level != '' && scope.row.level != null
                          ">
                          <el-rate class="rate-levl" disabled v-model="scope.row.level"></el-rate>
                        </div>
                        <div v-else class="color:#B0C4DE">未填写</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
          <div></div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          ">
          <div style="width: 100%; height: 50px"></div>

          <!-- 低 -->
          <div style="display: flex">
            <div class="Footer-text-left">仓鼠潮玩欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">南京云游阁信息科技有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <router-link class="a-link" :to="'/userGuide'">
                  用户指南
                </router-link>
              </p> -->
              <!-- <p class="opt opt-let">
                <span class="title">关于我们</span>
                <router-link class="a-link" :to="'/contactUs'">
                  联系我们
                </router-link>
              </p> -->
              <p class="opt opt-let2">
                <span style="margin-left: -1px" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  18752036980
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <!-- <p style="line-height: 18px">
              <img src="../assets/hui.png" style="width: 18px; height: 18px; vertical-align: middle" alt="" />
              <a style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank">豫公网安备：41080039010-21001号</a>&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" style="line-height: 18px; color: #ffffff"
                target="_blank">豫B2-20210727</a>
            </p> -->
            <p style="padding-bottom: 20px; color: #b4c1cd">
              <!-- © Copyright 2020-2023 -->
              <span><a style="color: #ffffff" href="#">
                  南京云游阁信息科技有限公司
                </a></span><br />
              All Rights Reserved.
              <a style="color: #ffffff" href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">苏ICP备2024094700号-5</a>
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      tableData: [
        {
          msgType:'2',
          createTime:'2024-10-16 13:52:30',
          name:'张11',
          phone:'18595428759',
          describes:'发货太慢！',
          updateTime:'2024-10-17 09:22:15',
          level:'123'
        },
          {
          msgType:'1',
            createTime:'2024-10-25 23:45:25',
          name:'高11',
          phone:'18395428689',
          describes:'活动玩法',
            updateTime:'2024-10-26 13:08:02',
          level:'123'
        },
          {
          msgType:'1',
            createTime:'2024-10-28 10:10:05',
          name:'张11',
          phone:'17695428358',
          describes:'充值提现',
            updateTime:'2024-10-29 15:03:59',
          level:'123'
        },
           {
          msgType:'1',
             createTime:'2024-11-01 23:18:54',
          name:'秦11',
          phone:'15895426985',
          describes:'邀请返现',
             updateTime:'2024-11-02 10:42:25',
          level:'4'
        }
      ],
      timer: null,
      evaluationData: [],
    };
  },
  filters: {
    filtersName: function (value) {
      if (!value) return "";
      if (value.length > 3) {
          let text1 = value.substring(0, 1);
          return `${text1}**`;
        } else if (value.length == 3) {
          let text1 = value.substring(0, 1);
          return `${text1}**`;
        } else {
          let text1 = value.substring(0, 1);
          return `${text1}*`;
        }
    },
    filtersPhone: function (value) {
      if (!value) return "";
      let text1 = value.substring(0, 3);
      let text2 = value.substring(8, 11);
      return `${text1}*****${text2}`;
    },
  },
  created() {
    this.init();
  },
  mounted() {
    // 拿到表格挂载后的真实DOM
    const table = this.$refs.table;
    // 拿到表格中承载数据的div元素
    const divData = table.bodyWrapper;
    // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    this.timer = setInterval(() => {
      // 元素自增距离顶部1像素
      divData.scrollTop += 1;
      // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
      if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
        // 重置table距离顶部距离
        divData.scrollTop = 0;
      } else {
        if (divData.scrollTop == 130) {
          divData.scrollTop = 0;
        }
      }
    }, 50);
  },
  methods: {
    init() {
      this.$axios({
        method: "post",
        url: "/freight/officialWebsiteData/msgConsultingList",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        this.tableData = res.data.result;
      });
    },
    clickCriteriaIcon() {
      this.criteriaIcon = !this.criteriaIcon;
    },
    // 入
    move() {
      clearInterval(this.timer);
    },
    // 出
    remove() {
      const table = this.$refs.table;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      this.timer = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0;
        } else {
          if (divData.scrollTop == 130) {
            divData.scrollTop = 0;
          }
        }
      }, 50);
    },
  },
};
</script>
<style >
.el-rate__icon {
  font-size: 23px !important;
  margin-right: -5px !important;
}
</style>
<style scoped >
.Header-img {
  background-image: url("../assets/sourceInformation.png");
  width: 100%;
  height: 232px;
}
.Content-tblo {
  width: 1350px;
  background-color: #ffffff;
  text-align: center;
}

/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}
.ivu-layout-footer {
  padding: 0 !important;
}
.layout-logo {
  width: 100px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
  top: -13px;
  left: 50px;
}

.layout-nav {
  width: 650px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}
.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/evaluationPublicity.vue